import React from 'react';
import './Banner.css'

const Banner = () => {
    return (
        <div className="banner-img">
      <img src="https://imgdb.net/storage/uploads/d74f3150f1571431272e653db8d0a7082b1ecd88c6321cd900eb117b441ee1f7.jpg" alt=""/></div>
    );
};

export default Banner;